<div class="description-block">
  <h4 class="title mb-4">{{title}}<span class="subline"></span></h4>
  <div [innerHTML]="text" class="description"></div>
</div>
